<template>
    <div class="modal login">
        <div class="wrapper login__wrapper login__wrapper--pin">
            <IconClose class="close" @click="closeLoginModal"></IconClose>

            <div class="login__pin">
                <p class="login__title"> 
                    <IconSpeaker class="login__speaker" @click="speechSynthesis(text)"></IconSpeaker>
                    {{ text }}
                </p>
                <p class="login__subtitle">PIN pozwoli Ci na dostęp do pełnych funkcjonalności Krainy ABC</p>  

                <div class="login__pins">
                    <div class="login__form-pin">
                        <label for="pin" class="login__label-pin">PIN: <span>(4 cyfry z przedziału 1-9)</span></label>
                        <div class="login__input-wrapper">
                            <input v-model="pin" id="pin" :type="showPin ? 'text' : 'password'" class="login__input-pin" :class="{'error': pinError}" @keypress="isNumber"/>
                            <IconEye class="login__form-eye" @mousedown="showPin = !showPin" @mouseup="showPin = !showPin"></IconEye>
                        </div>
                    </div>

                    <div class="login__form-pin">
                        <label for="pinRepeat" class="login__label-pin">Powtórz PIN: <span>(4 cyfry z przedziału 1-9)</span></label>
                        <div class="login__input-wrapper">
                            <input v-model="pinRepeat" id="pinRepeat" :type="showPinRepeat ? 'text' : 'password'" class="login__input-pin" :class="{'error': pinRepeatError}" @keypress="isNumber"/>
                            <IconEye class="login__form-eye" @mousedown="showPinRepeat = !showPinRepeat" @mouseup="showPinRepeat = !showPinRepeat"></IconEye>
                        </div>
                    </div>

                    <div class="errors" v-if="error">
                        <span>{{ error }}</span>
                    </div>
                </div>

                <button class="btn" @click.prevent="savePin"><span>Zapisz</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";
import IconEye from "../elements/icons/IconEye.vue";
import IconClose from "../elements/icons/IconClose.vue";
import { useToast } from "vue-toastification";

const toast = useToast()

export default {
    name: "LoginPIN",
    components: {
        IconSpeaker,
        IconClose,
        IconEye
    },
    data() {
        return {
            SAVE_PIN: `${window.__apiHost}/api/account/user-application-data/pin?device=www&src=krainaabc`,
            pin: '',
            pinRepeat: '',
            pinError: '',
            pinRepeatError: '',
            error: '',
            showPin: false,
            showPinRepeat: false,
            text: 'Ustal PIN dla konta rodzica'
        };
    },
    methods: {
        isNumber(e) {
            if ((!/[1-9]/.test(e.key) && e.key !== 'Backspace') || (e.target.value.length === 4 && e.key !== 'Backspace')) {
                e.preventDefault();
            }
        },
        savePin() {
            if(this.pin.length < 4 || this.pinRepeat.length < 4) {
                this.error = 'PIN musi się składać z 4 cyfr'

                if(this.pin.length < 4) {
                    this.pinError = true;
                } else {
                    this.pinError = false;
                }

                if(this.pinRepeat.length < 4) {
                    this.pinRepeatError = true;
                } else {
                    this.pinRepeatError = false;
                }

                return;
            }

            if(this.pin !== this.pinRepeat) {
                this.error = 'Wartości obu pól muszą być takie same';
                this.pinRepeatError = true;
                return;
            }

            this.error = '';
            this.pinError = false;
            this.pinRepeatError = false;

            const data = {};
            data['src'] = 'krainaabc';
            data['pin'] = parseInt(this.pin);
            data['pin_repeat'] = parseInt(this.pinRepeat);

            axios
                .post(this.SAVE_PIN, data)
                .then(() => {
                    toast.success("PIN został ustawiony");
                    this.$emit("modalPinToggle", true);
                    this.$store.dispatch('globalUserData');
                })
                .catch(() => {
                    toast.error("Nie udało się ustawić PINu");
                });
        },
        closeLoginModal() {
            this.$emit("modalPinToggle", false);
        }
    }
};
</script>